import { useReveal } from "../../hooks/useReveal";

const areas = [
  { city: "San Antonio", state: "TX", primary: true },
  { city: "Boerne", state: "TX", primary: false },
  { city: "New Braunfels", state: "TX", primary: false },
  { city: "Schertz", state: "TX", primary: false },
  { city: "Converse", state: "TX", primary: false },
  { city: "Universal City", state: "TX", primary: false },
  { city: "Helotes", state: "TX", primary: false },
  { city: "Stone Oak", state: "TX", primary: false },
  { city: "Texas Hill Country", state: "TX", primary: false },
];

export default function ServiceAreasSection() {
  const ref = useReveal<HTMLElement>();

  return (
    <section ref={ref} className="bg-pk-cream py-28 overflow-hidden">
      <div className="max-w-screen-xl mx-auto px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-start">
          {/* Left */}
          <div className="reveal-left">
            <span className="font-sans text-xs tracking-widest3 uppercase text-pk-gold">Service Coverage</span>
            <h2 className="font-display text-5xl md:text-6xl font-medium text-pk-charcoal mt-4 leading-tight">
              Serving San Antonio<br />
              <em>&amp; Surrounding Areas</em>
            </h2>
            <p className="font-sans text-sm text-pk-muted mt-6 leading-7 max-w-md">
              Precious Keepsakes Photography proudly serves families across the greater San Antonio metro area and Texas Hill Country. Stephanie is available for on-location sessions throughout the region.
            </p>

            {/* Areas grid */}
            <div className="mt-10 flex flex-wrap gap-2">
              {areas.map((area) => (
                <span
                  key={area.city}
                  className={`font-sans text-xs tracking-wide px-4 py-2.5 rounded-sm whitespace-nowrap transition-all duration-300 ${
                    area.primary
                      ? "bg-pk-charcoal text-white"
                      : "bg-white border border-pk-light text-pk-charcoal hover:border-pk-gold hover:text-pk-gold cursor-pointer"
                  }`}
                >
                  {area.city}, {area.state}
                </span>
              ))}
            </div>

            {/* Travel note */}
            <div className="mt-8 flex items-start gap-3">
              <div className="w-8 h-8 flex items-center justify-center bg-pk-gold/10 rounded-sm flex-shrink-0">
                <i className="ri-road-map-line text-pk-gold text-sm" />
              </div>
              <p className="font-sans text-xs text-pk-muted leading-6 pt-1">
                Destination and travel sessions available throughout Texas. Contact Stephanie to discuss your location and travel options.
              </p>
            </div>
          </div>

          {/* Right: Map — taller, more prominent */}
          <div className="reveal-right">
            <div className="w-full h-[480px] rounded-sm overflow-hidden border border-pk-light">
              <iframe
                title="Precious Keepsakes Photography — San Antonio, TX"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d228868.5555046478!2d-98.70025085!3d29.424121450000003!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x865c58af04d00ebd%3A0x856e13b10a016bc!2sSan%20Antonio%2C%20TX!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>

            {/* Under-map contact strip */}
            <div className="mt-4 bg-pk-charcoal rounded-sm px-6 py-4 flex items-center justify-between gap-4">
              <div>
                <p className="font-sans text-xs text-white/50 tracking-wide">Studio location</p>
                <p className="font-sans text-sm text-white font-medium mt-0.5">San Antonio, Texas</p>
              </div>
              <a
                href="tel:2108154698"
                className="flex items-center gap-2 bg-pk-gold text-white font-sans text-xs tracking-widest uppercase px-5 py-2.5 rounded-sm hover:bg-white hover:text-pk-charcoal transition-colors duration-300 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line" />
                <span>Call Now</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
